DialogController = App.loadClass 'core::Angular/DialogController'

class exports.AddGrowerTreatmentController extends DialogController
    constructor: (
        @scope,
        $transitions,
        @modalInstance,
        @http,
        autoSelect
    ) ->
        super @scope, $transitions, @modalInstance
        @scope.title = 'Add Treatment'

        @scope.treatment = {
            name: ''
            crop: null
        }

        @scope.crops = []

        @http.get 'backend/core/crops'
        .then (response) -> response.data
        .then (crops) =>
            @scope.crops = crops
            if autoSelect?.crop?
                @scope.treatment.crop = crops.find (crop) -> crop.id is autoSelect.crop

    save: (pretend) =>
        @http.post 'backend/grower/treatments', @scope.treatment
        .then (response) =>
            @modalInstance.close response.data unless pretend
